import { render, staticRenderFns } from "./BannerBlock.vue?vue&type=template&id=618a085e&scoped=true&"
import script from "./BannerBlock.vue?vue&type=script&lang=js&"
export * from "./BannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./styles/BannerBlock.scss?vue&type=style&index=0&id=618a085e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a085e",
  null
  
)

export default component.exports